import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfirmComponent } from '../Components/PopUps/ConfirmComponent';
import { ErrorPopUpComponent } from '../Components/PopUps/ErrorPopUpComponent';
import { PopUpBusyComponent } from '../Components/PopUps/PopUpBusyComponent';
import { AuthInterceptor } from '../RoutingAuth/auth.interceptor';

import { BaseService } from './BaseService';
import { BlobErrorHttpInterceptor } from './BlobErrorInterceptor';
import { AgreementService } from './Custom/ServiceAgreement';
import { AgreementMasterService } from './Custom/ServiceAgreementMaster';
import { AppUserService } from './Custom/ServiceAppUser';
import { ChatMessageService } from './Custom/ServiceChatMessage';
import { ChecklistService } from './Custom/ServiceChecklist';
import { ChecklistTaskService } from './Custom/ServiceChecklistTask';
import { ChecklistTaskStatusChangeService } from './Custom/ServiceChecklistTaskStatusChange';
import { CommunicationTemplateService } from './Custom/ServiceCommunicationTemplate';
import { CompanyService } from './Custom/ServiceCompany';
import { CompanyEmailService } from './Custom/ServiceCompanyEmail';
import { CompanyEmailDomainService } from './Custom/ServiceCompanyEmailDomain';
import { CompanyPhoneNumberService } from './Custom/ServiceCompanyPhoneNumber';
import { CompanyPromoCodeService } from './Custom/ServiceCompanyPromoCode';
import { CustomerAccountService } from './Custom/ServiceCustomerAccount';
import { CustomerInvoiceService } from './Custom/ServiceCustomerInvoice';
import { CustomerInvoiceItemService } from './Custom/ServiceCustomerInvoiceItem';
import { DeliveryZoneService } from './Custom/ServiceDeliveryZone';
import { DeliveryZoneGroupService } from './Custom/ServiceDeliveryZoneGroup';
import { EndUserCommunicationTrackerService } from './Custom/ServiceEndUserCommunicationTracker';
import { ImportFileTemplateService } from './Custom/ServiceImportFileTemplate';
import { LogService } from './Custom/ServiceLog';
import { OutsideLogService } from './Custom/ServiceOutsideLog';
import { PaymentService } from './Custom/ServicePayment';
import { PersonService } from './Custom/ServicePerson';
import { PickupDeliveryService } from './Custom/ServicePickupDelivery';
import { PickupDeliveryExtraFeeService } from './Custom/ServicePickupDeliveryExtraFee';
import { PickupDeliverySpecialItemService } from './Custom/ServicePickupDeliverySpecialItem';
import { PropertyItemService } from './Custom/ServicePropertyItem';
import { PropertyItemDocumentService } from './Custom/ServicePropertyItemDocument';
import { PropertyItemInspectionService } from './Custom/ServicePropertyItemInspection';
import { PropertyItemNoteService } from './Custom/ServicePropertyItemNote';
import { PropertyItemSpecialItemService } from './Custom/ServicePropertyItemSpecialItem';
import { QBService } from './Custom/ServiceQB';
import { ReferralSourceService } from './Custom/ServiceReferralSource';
import { ReportsService } from './Custom/ServiceReports';
import { ReservationService } from './Custom/ServiceReservation';
import { SatisfactionSurveyQuestionService } from './Custom/ServiceSatisfactionSurveyQuestion';
import { SatisfactionSurveyResponseService } from './Custom/ServiceSatisfactionSurveyResponse';
import { ScheduleService } from './Custom/ServiceSchedule';
import { ScheduleItemService } from './Custom/ServiceScheduleItem';
import { SearchService } from './Custom/ServiceSearch';
import { ShipmentBOLService } from './Custom/ServiceShipmentBOL';
import { ShipmentBOLDocumentService } from './Custom/ServiceShipmentBOLDocument';
import { StorageLocationService } from './Custom/ServiceStorageLocation';
import { StorageRackService } from './Custom/ServiceStorageRack';
import { StorageSpaceService } from './Custom/ServiceStorageSpace';
import { TimeZoneService } from './Custom/ServiceTimeZone';
import { TruckService } from './Custom/ServiceTruck';
import { TypeCancellationReasonService } from './Custom/ServiceTypeCancellationReason';
import { TypeCountryService } from './Custom/ServiceTypeCountry';
import { TypeCustomerAccountService } from './Custom/ServiceTypeCustomerAccount';
import { TypeOrderTagService } from './Custom/ServiceTypeOrderTag';
import { TypePaymentSourceService } from './Custom/ServiceTypePaymentSource';
import { TypePropertyItemService } from './Custom/ServiceTypePropertyItem';
import { TypeStorageFeeService } from './Custom/ServiceTypeStorageFee';
import { TypeTruckService } from './Custom/ServiceTypeTruck';
import { UploadedFileService } from './Custom/ServiceUploadedFile';
import { DialogService } from './DialogService';
import { MiniProfilerInterceptor } from './ProfiledHttpInterceptor';
import { UrlService } from './UrlService';
import { PhoneAppService } from './Custom/ServicePhoneApp';
import { TruckLocationService } from './Custom/ServiceTruckLocation';
import { ExtraPhotoExcuseService } from './Custom/ServiceExtraPhotoExcuse';
import { ZipCodeInfoService } from './Custom/ServiceZipCodeInfo';
import { FuelPriceService } from './Custom/ServiceFuelPrice';
import { FuelPriceRangeService } from './Custom/ServiceFuelPriceRange';



@NgModule({
	declarations: [
		ErrorPopUpComponent,
		PopUpBusyComponent,
		ConfirmComponent,
	],
	imports: [],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: MiniProfilerInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor, multi: true },
		UrlService,
		BaseService,
		DialogService,
		HttpClient,
		Title,

		AgreementService,
		AgreementMasterService,

		AppUserService,
		ChatMessageService,
		ChecklistService,
		ChecklistTaskService,
		ChecklistTaskStatusChangeService,
		CommunicationTemplateService,
		CompanyPromoCodeService,
		CompanyService,
		CustomerAccountService,
		CompanyEmailService,
		CompanyEmailDomainService,
		CompanyPhoneNumberService,
		CustomerInvoiceService,
		CustomerInvoiceItemService,
		DeliveryZoneGroupService,
		DeliveryZoneService,
		EndUserCommunicationTrackerService,
		ExtraPhotoExcuseService,
		FuelPriceService,
		FuelPriceRangeService,
		ImportFileTemplateService,
		LogService,
		OutsideLogService,
		PaymentService,
		PersonService,
		PhoneAppService,
		PickupDeliveryService,
		PickupDeliveryExtraFeeService,
		PickupDeliverySpecialItemService,
		PropertyItemDocumentService,
		PropertyItemService,
		PropertyItemNoteService,
		PropertyItemInspectionService,
		PropertyItemSpecialItemService,
		QBService,
		ReferralSourceService,
		ReportsService,
		ReservationService,
		ScheduleItemService,
		SatisfactionSurveyQuestionService,
		SatisfactionSurveyResponseService,
		ScheduleService,
		SearchService,
		ShipmentBOLService,
		ShipmentBOLDocumentService,
		StorageLocationService,
		StorageRackService,
		StorageSpaceService,
		TimeZoneService,
		TruckService,
		TruckLocationService,
		TypeCancellationReasonService,
		TypeCountryService,
		TypeCustomerAccountService,
		TypeOrderTagService,
		TypePaymentSourceService,
		TypePropertyItemService,
		TypeStorageFeeService,
		TypeTruckService,
		UploadedFileService,
		ZipCodeInfoService
	],
})
export class ServiceModule { }
